import { render } from "./SpaceWidgetFpImmersionCountdownComponent.vue?vue&type=template&id=6c1367b8&scoped=true&ts=true"
import script from "./SpaceWidgetFpImmersionCountdownComponent.vue?vue&type=script&lang=ts"
export * from "./SpaceWidgetFpImmersionCountdownComponent.vue?vue&type=script&lang=ts"

import "./SpaceWidgetFpImmersionCountdownComponent.vue?vue&type=style&index=0&id=6c1367b8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1367b8"]])

export default __exports__